import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/styles';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import theme from 'theme';

const StyledGrid = styled(Grid)({
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'space-evenly',
  },
});
const StyledItemGrid = styled(Grid)({
  [theme.breakpoints.up('xs')]: {
    margin: '10px 0px 10px 0px',
  },
});
const DateFilter = ({ submitFilter }) => {
  const { t } = useTranslation();
  const { filters } = useEvents();

  return (
    <StyledGrid item container xs={12} justifyContent="space-evenly">
      <StyledItemGrid item>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={t('time_start')}
            name={'time_start'}
            placeholder={t('time_start')}
            value={filters?.time_start === undefined ? null : filters.time_start}
            onChange={(event) => {
              if (event && event.toISOString) {
                submitFilter({ time_start: event.toISOString() });
              }
            }}
            renderInput={(params) => <TextField {...params} error={false} />}
            views={['year', 'month', 'day']}
          />
        </LocalizationProvider>
      </StyledItemGrid>
      <StyledItemGrid item>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={t('time_end')}
            name={'time_end'}
            placeholder={t('time_end')}
            value={filters?.time_end === undefined ? null : filters.time_end}
            onChange={(event) => {
              if (event && event.toISOString) {
                submitFilter({ time_end: event.toISOString() });
              }
            }}
            renderInput={(params) => <TextField {...params} error={false} />}
            views={['year', 'month', 'day']}
          />
        </LocalizationProvider>
      </StyledItemGrid>
    </StyledGrid>
  );
};

DateFilter.propTypes = {
  submitFilter: PropTypes.func,
};

DateFilter.defaultProps = {
  submitFilter: () => {},
};

export default DateFilter;
